module.exports = __webpack_public_path__ + "img/interface-mobile-en.34571327.png";